import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  Checkbox,
  Chip,
  IconButton,
  Select,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import { api, get, post, put } from "../../../utils/api";
import { useUser } from "../../../context/AuthContext";
import EditDialog from "../../../Components/Common/EditDialog";

function AddRole(props) {
  const { user } = useUser();
  const [selectedModules, setSelectedModules] = useState([]);
  const [moduleName, setmoduleName] = useState([
    "Select All",
    "Environment Dashboard",
    "Environment | Scope 1",
    "Environment | Scope 2",
    "Environment | Scope 3",
    "Social Dashboard",
    "Governance Dashboard",
    "Setup",
    "Roles & Permission",
    "Facility Master",
    "Masters",
    "ESG Reporting",
    "GRI",
    "BRSR",
    "CDP",
    "Value Chain",
    "Water Management",
    "Documentation",
  ]);
  const [facilities, setFacility] = useState([]);
  const [openSelect, setOpen] = useState(false);
  const [selectedModuleName, setselectedModuleName] = useState([]);
  const [PermissionsName, setPermissionsName] = useState([]);
  const [alreadyRole, setAlreadyUser] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const initialState = {
    remark: "",
    name: "",
    allowed_permissions: PermissionsName,
    moduleName: selectedModuleName,
    facility: "",
  };

  const [fromValue, setFromValue] = useState(initialState);
  const [fromValue2, setFromValue2] = useState(initialState);

  const [editDialog, setEditDialog] = useState(false);

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === fromValue2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    console.log("hiii");
    props.setValue(false);
    setEditDialog(false);
    resetForm();
    // }
  };
  const resetForm = () => {
    setselectedModuleName(props.index === 0 ? [] : props.index?.moduleName);
    setSelectedModules(props.index === 0 ? [] : props.index?.moduleName);
    setSelectedPermissions(
      props.index === 0 ? [] : props.index?.allowed_permissions
    );
    setFromValue(props.index === 0 ? initialState : props.index);
    setFromValue2(props.index === 0 ? initialState : props.index);
    setErrors({});
  };

  const fetchFacilities = async () => {
    try {
      const response = await get(`/master/getAllFacility`);
      setFacility(response.data.data);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  useEffect(() => {
    axios
      .get(`${api}/auth/getPermissions`)
      .then((res) => {
        console.log(res.data.data, "resres");
        setPermissionsName(res.data.data);
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }, []);

  useEffect(() => {
    if (props.index._id !== 0) {
      const state = {
        remark: props.index?.remark,
        name: props.index?.name || "",
        moduleName: props.index?.moduleName || [],
        allowed_permissions: (props.index?.allowed_permissions || []).map(
          (item) => item._id
        ),
        facility: props.index?.facility?._id || "",
      };
      setFromValue(state);
      setFromValue2(state);
      setselectedModuleName(props.index?.moduleName || []);
      setSelectedModules(props.index?.moduleName || []);
      setSelectedPermissions(props.index?.allowed_permissions || []);
      setAlreadyUser(props.index?._id ? true : false);
    } else {
      const state = {
        remark: "",
        name: "",
        allowed_permissions: [],
        moduleName: selectedModuleName,
        facility: "",
      };
      setFromValue(state);
      setFromValue2(state);
    }
  }, [props.index]);

  console.log("role", props.index);

  const handleModuleModleChange = (event) => {
    const value = Array.isArray(event.target.value)
      ? event.target.value.filter((item) => item !== "Select")
      : [];
    // const value =  event.target.value
    console.log("Filtered value:", value); // Debugging the selected values
    // let newSelectedData = [...selectedModules]
    let newSelectedData = value.includes("Select All")
      ? moduleName.filter((item) => item !== "Select All")
      : [...selectedModules];
    if (value.includes("Select All")) {
      setSelectedModules(moduleName.filter((item) => item !== "Select All"));
      setselectedModuleName(moduleName.filter((item) => item !== "Select All"));
      setFromValue({
        ...fromValue,
        moduleName: moduleName.filter((item) => item !== "Select All"), // Ensure no duplicates in `fromValue`
      });
      setmoduleName((prev) => ["Unselect All", ...prev.slice(1)]);
    } else if (value.includes("Unselect All")) {
      setSelectedModules([]);
      setselectedModuleName([]);
      // setmoduleName((prev) => prev.filter((item) => item !== "Unselected"))
      setmoduleName((prev) => ["Select All", ...prev.slice(1)]);
      setFromValue({
        ...fromValue,
        moduleName: [], // Ensure no duplicates in `fromValue`
      });
    }
    //  else {
    //   console.log("newSelectedData++",newSelectedData,moduleName)
    //   // Remove "Selected All" and keep other selected modules
    //   setSelectedModules(moduleName.filter((item) => item !== "Selected All"));
    //   setselectedModuleName(moduleName.filter((item) => item !== "Selected All"));
    //   setmoduleName(["Unselected",...moduleName])
    // }
    else {
      // console.log("newSelectedData++--",newSelectedData,moduleName,value)
      // Regular selection

      value.forEach((item) => {
        newSelectedData.push(item); // Push each value individually
      });

      const uniqueValues = [...new Set(newSelectedData)];
      // if (value.includes("Selected All")){
      //   setSelectedModules(moduleName.filter((item) => item !== "Selected All"));
      //   setmoduleName(["Unselected",...moduleName])
      // }else if (value.includes("Unselected")) {
      //   setSelectedModules([]);
      //   setselectedModuleName([]);
      //   setmoduleName([...moduleName])
      // }
      console.log(newSelectedData, "uniqueValues");
      // Use Set to remove duplicates
      console.log(uniqueValues, "uniqueValues");
      setSelectedModules(uniqueValues);
      setselectedModuleName(uniqueValues);
      setFromValue({
        ...fromValue,
        moduleName: uniqueValues, // Ensure no duplicates in `fromValue`
      });
    }

    // Update the `fromValue` object
    //   setFromValue({
    //     ...fromValue,
    //     moduleName: value.includes("Selected All")
    //     ? moduleName.filter((module) => module !== "Selected All")
    //     : [...new Set(value)], // Ensure no duplicates in `fromValue`
    // });

    // Close dropdown
    setOpen(false);
  };

  const handleModuleChange = (event) => {
    const { value, checked } = event.target; // Get value and checked status from the event
    console.log("Selected value:", value, "Checked:", checked);

    // Update selectedPermissions based on whether the checkbox is checked or unchecked
    setSelectedPermissions((prevSelected) => {
      let updatedPermissions;
      // if  value === "66de8fb8f978a340f62bdcb9"?setErrors({...errors,moduleName:"Delete"})
      if (checked) {
        // If checked, add the new permission to selectedPermissions
        const selectedItem = PermissionsName.find((perm) => perm._id === value);
        if (selectedItem && !prevSelected.some((perm) => perm._id === value)) {
          updatedPermissions = [...prevSelected, selectedItem]; // Add the new permission to the array
        } else {
          updatedPermissions = prevSelected; // No changes
        }
      } else {
        // If unchecked, remove the permission from selectedPermissions
        updatedPermissions = prevSelected.filter((perm) => perm._id !== value);
      }
      const Delete = updatedPermissions
        .filter((perm) => perm.name === "Delete")
        .join("");

      if (updatedPermissions.length === 1 && Delete) {
        setFromValue((prevFromValue) => ({
          ...prevFromValue,
          allowed_permissions: "Delete", // Sync allowed_permissions with selectedPermissions
        }));
      } else {
        setErrors({ ...errors, allowed_permissions: "" });
        setFromValue((prevFromValue) => ({
          ...prevFromValue,
          allowed_permissions: updatedPermissions.map((perm) => perm._id), // Sync allowed_permissions with selectedPermissions
        }));
      }
      return updatedPermissions;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    const { name } = fromValue;

    // Validate `name`
    if (!name || name.trim() === "") {
      newErrors.name = "Name is required.";
    }

    // Validate `allowed_permissions`
    // if (!allowed_permissions || allowed_permissions === "Tap to Select") {
    //   newErrors.allowed_permissions = "Please select the any option";
    // }

    // Validate `allowed_permissions`
    // if (
    //   !fromValue.allowed_permissions ||
    //   fromValue.allowed_permissions.length === 0
    // ) {
    //   newErrors.allowed_permissions = "Please select at least one permission.";
    // } else if (fromValue.allowed_permissions === "Delete") {
    //   newErrors.allowed_permissions = "Only delete access cann't be given";
    // }

    // if (!fromValue.moduleName || fromValue.moduleName.length === 0) {
    //   newErrors.moduleName = "Please select at least one module.";
    // }
    if (user?.companyAdmin === true && !fromValue.facility) {
      newErrors.facility = "Facility is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDeleteModule = (item) => {
    const updatedValues = selectedModuleName.filter((value) => value !== item);
    setselectedModuleName(updatedValues);
    setSelectedModules(updatedValues);
    setFromValue({
      ...fromValue,
      moduleName: updatedValues,
    });
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setFromValue((prevFromValue) => ({
      ...prevFromValue,
      facility: name === "facility" ? value : prevFromValue.facility,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }

    const url = alreadyRole
      ? `${api}/auth/updateRole?Id=${props.index?._id}`
      : `${api}/auth/createRole`;

    const method = alreadyRole ? put : post;

    try {
      const res = await method(url, fromValue);

      props.setValue(false);
      props.setsnackOpen({
        open: true,
        message: res?.data?.message,
        severity: "success",
      });

      props.fetchRoles();
      resetForm();

      if (!alreadyRole) {
        localStorage.setItem("roleId", res.data._id);
      }
    } catch (err) {
      console.error(err?.response?.data, "Error while saving role");
      props.setsnackOpen({
        open: true,
        message:
          err?.response?.data?.message ||
          "An error occurred while saving the role",
        severity: "error",
      });
    }
  };

  console.log("form", fromValue);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "27rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.index !== 0 ? "Edit Role" : "Add Role"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Name of Role
        </Typography>

        <CustomTextField
          variant="outlined"
          value={fromValue.name}
          onChange={handleChange}
          fullWidth
          name="name"
          placeholder="Enter Name"
          error={!!errors.name}
          InputLabelProps={{
            style: { color: errors.name ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}

        {user?.companyAdmin && (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Facility
            </Typography>
            <CustomTextField
              select
              variant="outlined"
              value={fromValue.facility || "Tap to Select"}
              onChange={handleDropdownChange}
              fullWidth
              name="facility"
              placeholder="Tap to Select"
              error={!!errors.facility}
              InputLabelProps={{
                style: { color: errors.facility ? "#D34040" : undefined },
              }}
            >
              <MenuItem value="Tap to Select" disabled>
                Tap to Select
              </MenuItem>
              {facilities.map((item, i) => (
                <MenuItem key={i} value={item?._id}>
                  {item.facilityName}
                </MenuItem>
              ))}
            </CustomTextField>

            {errors.facility && (
              <Typography variant="body2" color="#D34040">
                {errors.facility}
              </Typography>
            )}
          </>
        )}

        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Module's Name
        </Typography>
        {Array.isArray(selectedModuleName) &&
          selectedModuleName.length > 0 &&
          selectedModuleName.slice(0, 5).map((item) => {
            return (
              <Chip
                key={item}
                label={item}
                onDelete={() => handleDeleteModule(item)}
                sx={{
                  bgcolor: "#1C486B",
                  color: "white",
                  height: "28px",
                  mb: 0.5,
                  "& .MuiChip-deleteIcon": {
                    color: "white",
                    "&:hover": {
                      color: "white",
                    },
                  },
                }}
                deleteIcon={
                  <IconButton sx={{ color: "white" }}>
                    <CancelIcon sx={{ height: "18px", width: "18px" }} />
                  </IconButton>
                }
              />
            );
          })}

        <Select
          multiple
          open={openSelect}
          variant="outlined"
          value={["Select"]}
          onChange={handleModuleModleChange}
          fullWidth
          name="modulesName"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          placeholder="Tap to Select"
          renderValue={(selected) => {
            console.log("selectedselected", selected);
            if (!Array.isArray(selected)) return "";
            if (selected.length === 0) return "Tap to Select";
            return selected.join(", ");
          }}
          error={!!errors.moduleName}
          displayEmpty
          InputLabelProps={{
            "aria-label": "Without label",
            style: { color: errors.moduleName ? "#D34040" : undefined },
          }}
          sx={{ height: "40px" }}
        >
          <MenuItem disabled value=""></MenuItem>
          {moduleName.map((item, i) => (
            <MenuItem
              key={i}
              value={item}
              sx={{
                backgroundColor: selectedModules.includes(item)
                  ? "rgba(0, 123, 255, 0.2)"
                  : "transparent",

                "&:hover": {
                  backgroundColor: "rgba(0, 123, 255, 0.2)", // Light hover effect
                },
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {item}
            </MenuItem>
          ))}
        </Select>
        {errors.moduleName && (
          <Typography variant="body2" color="#D34040">
            {errors.moduleName}
          </Typography>
        )} */}

        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Permissions
        </Typography>

        <FormGroup>
          {PermissionsName.map((item) => (
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleModuleChange}
                  value={item._id}
                  checked={selectedPermissions.some(
                    (perm) => perm._id === item._id
                  )}
                />
              }
              label={item.name}
            />
          ))}
        </FormGroup>

        {errors.allowed_permissions && (
          <Typography variant="body2" color="#D34040">
            {errors.allowed_permissions}
          </Typography>
        )} */}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>

        <TextField
          rows={2}
          variant="outlined"
          value={fromValue.remark}
          onChange={handleChange}
          fullWidth
          name="remark"
          placeholder="Brief"
          multiline
        ></TextField>

        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.value}
        onClose={handleClose}
      >
        {list()}
      </Drawer>
    </div>
  );
}
export default AddRole;

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
